import { CREATIVE_WORLD } from './CreativeBiome';
// A shared built-in village, independent of account/admin permissions.
export const CREATIVE_VILLAGE_ID = 2_147_483_640;
export const isCreativeVillage = (villageId: number): boolean => villageId === CREATIVE_VILLAGE_ID;

export const CREATIVE_TERRAIN_WIDTH = CREATIVE_WORLD.sampleWidth;
export const CREATIVE_BUILD_HALF_WIDTH = CREATIVE_WORLD.buildHalfWidth;
// Keep in sync with creativeBuildingMaxHeightAboveTerrain on the server.
export const CREATIVE_BUILD_MAX_HEIGHT_ABOVE_TERRAIN = 2;
